// extracted by mini-css-extract-plugin
export default {"wrapper":"dS-z","firstToReview":"eS-z","productCards":"fS-z","productCard":"gS-z","stars":"hS-z","hidden":"iS-z"};